module.exports = __webpack_public_path__ + "img/life_style_level_3_50000.c6e95568.jpg";